var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('main-visual', {
    attrs: {
      "code": "recruitment-pc",
      "pc": ""
    }
  }), _c('main-visual', {
    attrs: {
      "code": "recruitment-mobile",
      "mobile": ""
    }
  })], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('recruitment-list-toggle'), _c('recruitment-list-filter', {
    staticClass: "mb-10 mb-md-20 mb-lg-28"
  }), _vm.items.length ? [_c('v-row', {
    staticClass: "my-n10 my-lg-n20"
  }, [_vm._l(_vm.items.slice(0, 8), function (item) {
    return [_c('v-col', {
      key: item._id,
      staticClass: "py-10 py-lg-20",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "3"
      }
    }, [_c('main-recruitment-card', {
      attrs: {
        "recruitment": item
      }
    })], 1)];
  }), 4 < _vm.items.slice(0, 8).length ? [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('main-banner', {
    staticClass: "my-40 my-lg-80",
    attrs: {
      "code": "recruitment-sub-1-pc",
      "pc": ""
    }
  }), _c('main-banner', {
    staticClass: "my-40 my-lg-80",
    attrs: {
      "code": "recruitment-sub-1-mobile",
      "mobile": ""
    }
  })], 1)] : _vm._e(), _vm._l(_vm.items.slice(8, 16), function (item) {
    return [_c('v-col', {
      key: item._id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "3"
      }
    }, [_c('main-recruitment-card', {
      attrs: {
        "recruitment": item
      }
    })], 1)];
  }), 4 < _vm.items.slice(8, 16).length ? [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('main-banner', {
    staticClass: "my-40 my-lg-80",
    attrs: {
      "code": "recruitment-sub-2-pc",
      "pc": ""
    }
  }), _c('main-banner', {
    staticClass: "my-40 my-lg-80",
    attrs: {
      "code": "recruitment-sub-2-mobile",
      "mobile": ""
    }
  })], 1)] : _vm._e()], 2), _c('div', {
    staticClass: "mt-40 mt-lg-60"
  }, [_c('v-pagination', {
    staticClass: "my-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  })], 1)] : [_c('v-layout', {
    staticClass: "page-text page-text--lg border-top pt-12 pt-lg-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_vm._v(" 등록된 채용공고가 없습니다. ")])]], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }